import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ROLES } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Account() {
  const { user, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password changed");
      setCur("");
      setPw("");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="max-w-lg space-y-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">Account</p>
        <h1 className="mt-1 text-3xl font-extrabold tracking-tight">{user.name}</h1>
        <p className="text-sm text-muted-foreground">{user.email} · {ROLES[user.role]}</p>
      </div>
      <form onSubmit={save} className="space-y-4 rounded-2xl border bg-card p-6">
        <h3 className="font-bold">Change password</h3>
        <div className="space-y-1.5"><Label>Current password</Label><Input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} data-testid="account-current-password" /></div>
        <div className="space-y-1.5"><Label>New password (min 8 characters)</Label><Input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="account-new-password" /></div>
        <button type="submit" data-testid="account-save-btn" className="rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground">Update password</button>
      </form>
      <button onClick={logout} data-testid="account-logout-btn" className="text-sm text-muted-foreground hover:text-foreground lg:hidden">Sign out</button>
    </div>
  );
}
